'use client';
import styled from 'styled-components';

export const StyledCollapsibleMenu = styled.div`
  max-width: 343px;
  border-radius: 32px;
  background-color: ${props => props.theme.colors.neutral.white};
`;

export const MenuButton = styled.div`
  max-height: ${props => props.maxHeight};
  display: flex;
  color: ${props => props.theme.colors.text.secondary};
  justify-content: space-between;
  align-items: center;
  ${props => props.theme.typography.button}
  padding: ${props => props.theme.spacing(5, 3, 5, 6)};
`;

export const IconContainer = styled.div`
  border-radius: 100px;
  min-width: 50px;
  min-height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.colors.background.base};
`;

export const ExpandedMenu = styled.div``;
